import StudyToday from "./home/StudyToday";
import Recommended from "./home/Recommended";
import CollectCom from "./home/CollectCom";
import TeacherTop from "./home/TeacherTop";
import Banners from "./home/Banners";
import LabelCom from "./home/LabelCom";
import CommonFunctions from "./home/CommonFunctions";
import Draggable from "react-draggable";
import PopView from "./home/PopView";
import HomeVideo from "./home/HomeVideo";
import NoticeWidget from "./notice/widget";
import { useNavigate } from "react-router-dom";
import "./Home.less";

import { entryTestCondition } from "api/textbook";
import { useEffect } from "react";

function Home() {
  const navigate = useNavigate();

  const init = async () => {
    const res = await entryTestCondition();
    if (res.code === 200) {
      if (res.data.is_show === true) {
        localStorage.setItem(
          "popIntroTest",
          `${new Date().getFullYear()}-${
            new Date().getMonth() + 1
          }-${new Date().getDate()}`
        );
        navigate("/introTest?isHome=true", { replace: true });
      }
    }
  };
  useEffect(() => {
    if (
      localStorage.getItem("popIntroTest") !==
      `${new Date().getFullYear()}-${
        new Date().getMonth() + 1
      }-${new Date().getDate()}`
    ) {
      init();
    }
  }, []);
  return (
    <div className="home-context">
      <NoticeWidget />
      <div className="divider"></div>
      <StudyToday />
      <div className="divider"></div>
      <LabelCom
        callback={() => navigate("/main/learn/0")}
        link="更多外教"
        title="明星外教"
      />
      <div className="divider"></div>
      <TeacherTop />
      <div className="divider"></div>
      <CommonFunctions />
      <div className="divider"></div>
      <Banners />
      <div className="divider"></div>
      <LabelCom
        callback={() => navigate("/main/textbook/0")}
        link="全部课程"
        title="课程系列"
      />
      <div className="divider"></div>
      <Recommended />
      <div className="divider"></div>
      <LabelCom
        callback={() => navigate("/main/textbook/0")}
        link="全部教材"
        title="收藏教材"
      />
      <div className="divider"></div>
      <CollectCom />
      <div className="divider"></div>
      <HomeVideo />
      <Draggable bounds="parent" cancel=".img">
        <div className="kf">
          <div className="img" onClick={() => navigate("/mine/service")}></div>
          <div className="text">在线客服</div>
        </div>
      </Draggable>
      <PopView />
    </div>
  );
}

export default Home;
